import axios from "axios";

export function getWeekTemplates(companyKey) {
    return axios
        .get(`api/weektemplates/${companyKey}`)
        .then((res) => res.data);
}

export function getWeekTemplateById(id) {
    return axios
        .get(`api/weektemplates/by-id/${id}`)
        .then((res) => res.data);
}

export function createWeekTemplate(template) {
    return axios
        .post(`api/weektemplates`, template)
        .then((res) => res.data);
}

export function updateWeekTemplate(id, template) {
    return axios
        .put(`api/weektemplates/${id}`, template)
        .then((res) => res.data);
}